// extracted by mini-css-extract-plugin
export default {"contentLeft":"ContentLeft-module__contentLeft--d5ca"};